// 值必须是symbol
export default {
  // 学员详情页面修改学员信息
  studentManageListRefresh: Symbol('学员管理页面列表刷新'),
  // 班级详情页面修改学员信息
  classManageListRefresh: Symbol('班级管理页面列表刷新'),
  // 编辑课价信息
  courseManageListRefresh: Symbol('课程管理页面列表刷新'),
  // 编辑精彩瞬间视频类型
  momentTypeListRefresh: Symbol('精彩瞬间视频类型列表刷新'),
  // 应用列表刷新
  appStoreListRefresh: Symbol('应用列表刷新'),
  // 菜单刷新
  appNavListRefresh: Symbol('菜单刷新'),
  // 课表刷新
  visualCourseRefresh: Symbol('排课管理可视化课表刷新'),
  // 排课管理列表刷新
  courseArrangeListRefresh: Symbol('排课管理列表刷新'),
  // 打开任务中心弹窗
  openTaskCenterpopup: Symbol('打开任务中心弹窗'),
};
